import React from "react";
import { Heading } from "@americanexpress/dls-react";
import { useTranslation } from "react-i18next";
import FormField from "../../Common/FormField";
import { COUNTRIES_WITH_CITY_FIELD } from "../../Common/constants";

const PASecurityLoginSection = ({ formik, isModifyUser, country }) => {
  const { t } = useTranslation("common");
  const isIEC = country === t("access.INTERNATIONALEUROCARD");

  return (
    <section id="pa-security-login">
      <div className="row">
        <div className="col-xs-12">
          <Heading
            level={4}
            className="heading-4 dls-deep-blue pad-2-t pad-2-b"
          >
            {isModifyUser
              ? t("newUserUK.modifyPASecurityForLogin")
              : t("newUserUK.newPASecurityForLogin")}
          </Heading>
        </div>
      </div>
      <div className="row">
        {COUNTRIES_WITH_CITY_FIELD(t).includes(country) && (
          <FormField
            id="password"
            name="password"
            label={t("newuser.passwordLabel")}
            colmd="col-md-4"
            type="text"
            value={formik.values.password}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            error={formik.touched.password && formik.errors.password}
            tooltipText={t("newUserUK.passwordTooltip")}
          />
        )}
        <FormField
          id="verificationPin"
          name="verificationPin"
          label={t(
            isIEC
              ? "newuser.verificationPinFormatLabel"
              : "newuser.verificationPinLabel"
          )}
          colmd={isIEC ? "col-md-4 toolTipField" : "col-md-4"}
          value={formik.values.verificationPin}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          error={
            formik.touched.verificationPin && formik.errors.verificationPin
          }
          tooltipText={t("newUserUK.verificationPinTooltip")}
        />
        <FormField
          id="memorableDate"
          name="memorableDate"
          label={t(
            isIEC
              ? "newuser.memorableDateFormatLabel"
              : "newuser.memorableDateLabel"
          )}
          colmd="col-md-4"
          value={formik.values.memorableDate}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          maxLength={4}
          error={formik.touched.memorableDate && formik.errors.memorableDate}
          tooltipText={t("newUserUK.memorableDateTooltip")}
        />
        <FormField
          id="clueMemorableDate"
          name="clueMemorableDate"
          label={t("newuser.memorableDateClue")}
          colmd="col-md-4"
          value={formik.values.clueMemorableDate}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          error={
            formik.touched.clueMemorableDate && formik.errors.clueMemorableDate
          }
        />
      </div>
    </section>
  );
};

export default PASecurityLoginSection;
